var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7626 1.5H7.23757C6.45757 1.5 5.82007 2.13 5.82007 2.91V3.615C5.82007 4.395 6.45007 5.025 7.23007 5.025H10.7626C11.5426 5.025 12.1726 4.395 12.1726 3.615V2.91C12.1801 2.13 11.5426 1.5 10.7626 1.5Z",
    fill: "#81878E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.93 3.61511C12.93 4.80761 11.955 5.78261 10.7625 5.78261H7.23753C6.04503 5.78261 5.07003 4.80761 5.07003 3.61511C5.07003 3.19511 4.62003 2.93261 4.24503 3.12761C3.18753 3.69011 2.46753 4.80761 2.46753 6.09011V13.1476C2.46753 14.9926 3.97503 16.5001 5.82003 16.5001H12.18C14.025 16.5001 15.5325 14.9926 15.5325 13.1476V6.09011C15.5325 4.80761 14.8125 3.69011 13.755 3.12761C13.38 2.93261 12.93 3.19511 12.93 3.61511ZM9.28503 12.7126H6.00003C5.69253 12.7126 5.43753 12.4576 5.43753 12.1501C5.43753 11.8426 5.69253 11.5876 6.00003 11.5876H9.28503C9.59253 11.5876 9.84753 11.8426 9.84753 12.1501C9.84753 12.4576 9.59253 12.7126 9.28503 12.7126ZM11.25 9.71261H6.00003C5.69253 9.71261 5.43753 9.45761 5.43753 9.15011C5.43753 8.84261 5.69253 8.58761 6.00003 8.58761H11.25C11.5575 8.58761 11.8125 8.84261 11.8125 9.15011C11.8125 9.45761 11.5575 9.71261 11.25 9.71261Z",
    fill: "#81878E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.97d13c3e.svg";
export { ForwardRef as ReactComponent };